import type { ILangAndCountry } from '@/interface/IApi';
import type { IGetI18nPackage, II18nPackageRes } from '../../../../interface/ICommon';
import { client, officialServerClient } from '@/clientInstance';
import type { IGetCountryListArgs, IGetCountryListRes } from '@/interface/ICountry';
import { escapeCountryName } from '@/utils/shared/escapeCountryName';

// 获取主题活动列表
export const getI18nPackage = async ({ country, lang, packages }: IGetI18nPackage): Promise<II18nPackageRes> => {
    const result = await officialServerClient.get<II18nPackageRes['i18nPackage']>(`/common/i18n/package?lang=${lang}&country=${country}&packages=${JSON.stringify(packages)}`);
    return { i18nPackage: result };
};

export const fetchI18nPackage = async ({ lang, country }: ILangAndCountry): Promise<II18nPackageRes> => {
    const res = await getI18nPackage({ lang, country, packages: ['reo-product', 'threed', 'subscribe',
        'product-versions', 'common', 'flash-sale', 'contact-sales-form', 'store-product-attribute-category'] });
    for (const key in res.i18nPackage['product-versions']) {
        if (/[A-Z]/.test(key)) {
            res.i18nPackage['product-versions'][key.toLocaleLowerCase()] = res.i18nPackage['product-versions'][key];
        }
    }
    return res;
};

/**
 * @param args 获取国家列表
 * @returns
 */
export async function getCountryList(args: IGetCountryListArgs): Promise<IGetCountryListRes['data']> {
    const res = await client.get<IGetCountryListRes['data']>('countries?no-mobile-redirection=1', args as Record<string, string>);
    for (const item of res ?? []) {
        item.name = escapeCountryName(item.name);
    }
    return res;
}
